export default __webpack_public_path__ + "static/media/logo-black.f3f8b32d.svg";